import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var DotxShortcutSvg = function DotxShortcutSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M19.75 21a.75.75 0 0 0 .75-.75v-16h-.25V2.5l1.5 1v.25h-.25v18a.25.25 0 0 1-.25.25H10.065q.24-.485.423-1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M6.5 10.204A9 9 0 0 1 11 18c0 .867-.123 1.706-.352 2.5h9.102a.25.25 0 0 0 .25-.25v-16H6.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#41A5EE",
    d: "M20.5 1.549a.5.5 0 0 0-.207-.049H6.5A.5.5 0 0 0 6 2v2l.25.25h14L20.5 4v-.625l.25-.25V2.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B7CD3",
    fillRule: "evenodd",
    d: "m22 4.5-1.073-1.073a.25.25 0 0 0-.427.176V1.548a.5.5 0 0 1 .146.098l1.207 1.207a.5.5 0 0 1 .147.354zM20.5 4H6v.5h14.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103F91",
    d: "M18.25 15H14v.5h4.25a.25.25 0 1 0 0-.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185ABD",
    d: "M18.25 13.5H14v.5h4.25a.25.25 0 1 0 0-.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B7CD3",
    d: "M18.25 12H14v.5h4.25a.25.25 0 1 0 0-.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#41A5EE",
    d: "M18.25 10.5H14v.5h4.25a.25.25 0 1 0 0-.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185ABD",
    fillRule: "evenodd",
    d: "M2 9v-.5a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-1.014q.015-.248.014-.5a9 9 0 0 0-9-9",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F7F7",
    fillRule: "evenodd",
    d: "m10.164 14.208.867-3.708H9.986L9.5 13.022q.376.565.665 1.185M8.39 11.662 8.108 10.5H6.977q.766.511 1.413 1.162",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#605E5C",
    fillRule: "evenodd",
    d: "M21.5 21.75v-18h.5v18a.75.75 0 0 1-.75.75H9.796q.142-.245.269-.5H21.25a.25.25 0 0 0 .25-.25M10.488 21h9.262a.75.75 0 0 0 .75-.75v-16H20v16a.25.25 0 0 1-.25.25h-9.102a9 9 0 0 1-.16.5M6.5 4.25v5.954a9 9 0 0 0-.5-.268V4.25z",
    clipRule: "evenodd",
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.313 23.583q-1.793 0-3.053-1.245T0 19.295q0-1.27.647-2.288a4.36 4.36 0 0 1 1.725-1.57H0V14h5.39v5.39H3.954v-2.97a2.72 2.72 0 0 0-1.797.934 2.8 2.8 0 0 0-.719 1.917q0 1.201.839 2.038a2.78 2.78 0 0 0 2.037.837z"
  }));
};
export var DotxShortcut = function DotxShortcut(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: DotxShortcutSvg
  }));
};